export default "__VITE_ASSET__CNhbQclI__"